import { useTranslations } from '@vocab/react';
import {
  Dialog,
  Inline,
  Button,
  Text,
  Stack,
  IconDelete,
} from 'braid-design-system';

import translations from './.vocab';

interface Props {
  isOpen: boolean;
  submitting: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const ConfirmDeleteDialog = ({
  isOpen,
  onClose,
  onDelete,
  submitting,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Dialog
      id="confirm-delete-dialog"
      title={t('Are you sure you want to delete your account?')}
      description={
        <Text tone="secondary">
          {t('Once you confirmed account deletion, this can’t be undone.')}
        </Text>
      }
      open={isOpen}
      onClose={onClose}
      width="small"
    >
      <Stack space="xlarge">
        <Inline space="small" align="center" collapseBelow="tablet">
          <Button
            id="confirmDeleteButton"
            icon={<IconDelete />}
            tone="critical"
            onClick={onDelete}
            loading={submitting}
          >
            {t('Confirm delete')}
          </Button>
          <Button variant="transparent" onClick={onClose}>
            {t('Cancel')}
          </Button>
        </Inline>
      </Stack>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
